export default {
  getAgreementAttachment: (state) => state.agreementAttachment,
};
